module.exports = __webpack_public_path__ + "static/preview-piclife@2x-d4447b945032e4f098b6477c9e6c56c5.png";